import { useEffect, useRef, useState } from 'react';
import { db } from './db';
import { bus } from './bus';
import { clientId } from './api';

export const LOCAL_PROGRESS_VERSION = 1;
const MAX_BYTES = 256_000;
const MAX_KEYS = 500;

/** Game storage arrives from the sandboxed iframe: accept only a flat string map within limits. */
export function sanitizeStorage(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null;
  const keys = Object.keys(data);
  if (keys.length > MAX_KEYS) return null;
  let size = 0;
  for (const k of keys) {
    if (typeof data[k] !== 'string') return null;
    size += k.length + data[k].length;
    if (size > MAX_BYTES) return null;
  }
  return { ...data };
}

/** Device-only record: { v, guestId, data, updatedAt }. Older/invalid records are ignored, never thrown. */
export async function loadLocal(scope) {
  const rec = await db.kvGet(`progress:${scope}`).catch(() => null);
  if (!rec || rec.v > LOCAL_PROGRESS_VERSION) return {};
  return sanitizeStorage(rec.data) || {};
}

export const saveLocal = (scope, data) => db.kvSet(`progress:${scope}`, { v: LOCAL_PROGRESS_VERSION, guestId: clientId(), data, updatedAt: new Date().toISOString() });

export function useLocalProgress(scope) {
  const ref = useRef({});
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!scope) return undefined;
    let alive = true;
    setLoaded(false);
    loadLocal(scope).then((d) => { if (alive) { ref.current = d; setLoaded(true); } });
    return () => { alive = false; };
  }, [scope]);
  useEffect(() => (scope ? bus.on((m) => {
    if (m.type !== 'storage') return;
    const d = sanitizeStorage(m.data);
    if (d) { ref.current = d; saveLocal(scope, d); }
  }) : undefined), [scope]);
  return { loaded, get: () => ref.current };
}
